import api from "./api";

/**
 * Create a fact in a knowledge base
 * POST /v1/fact/create
 *
 * @param {Object} body
 * @param {string} body.knowledgebase_uuid
 * @param {string} body.title
 * @param {string} body.description
 * @param {"DRAFT"|"ACTIVE"|"PENDING"|"EXPIRED"} body.status
 * @param {"DOCUMENT"|"USER"|"AGENT"} body.source_type
 * @param {{ limit: number, type: "DAYS"|"WEEKS"|"MONTHS"|"YEARS" }=} body.expire_policy
 * @param {boolean} body.no_expire
 * @returns {Promise<Object>} API response { statusCode, msgCode, body, meta, requestId }
 */
export const createFact = async (body) => {
  const response = await api.post("/v1/fact/create", body);
  return response.data;
};

/**
 * Update a fact
 * POST /v1/fact/update
 *
 * @param {Object} body
 * @param {string} body.fact_uuid - Required
 * @param {string=} body.title - Optional
 * @param {string=} body.description - Optional
 * @param {"DRAFT"|"ACTIVE"|"PENDING"|"EXPIRED"=} body.status - Optional
 * @param {{ limit: number, type: "DAYS"|"WEEKS"|"MONTHS" }=} body.expiration_policy - Optional
 * @param {boolean=} body.no_expire - Optional
 * @returns {Promise<Object>} API response { statusCode, msgCode, body, meta, requestId }
 */
export const updateFact = async (body) => {
  const response = await api.post("/v1/fact/update", body);
  return response.data;
};

